<template>
  <div class="distributor-manager">
    <div class="dis-manager-search white-box">
      <div class="part">
        <span class="span-14">姓名</span>
        <el-input class="search-input" placeholder="请输入姓名" v-model="filterTerm.name"></el-input>
      </div>
      <div class="part">
        <span class="span-14">手机号</span>
        <el-input @blur="bl" class="search-input" placeholder="请输入手机号" v-model="filterTerm.mobile"></el-input>
      </div>
      <div class="part">
        <span class="span-14">创建时间</span>
        <el-date-picker
          v-model="filterTerm.createdAtStart"
          align="right"
          type="date"
          placeholder="选择起始日期">
        </el-date-picker>
        <span>-</span>
        <el-date-picker
          v-model="filterTerm.createdAtEnd"
          align="right"
          type="date"
          placeholder="选择终止日期">
        </el-date-picker>
      </div>
      <div class="part">
        <span class="span-14">状态</span>
        <el-select v-model="filterTerm.accountState">
          <el-option
            v-for="item in distributorStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="part">
        <span class="span-14">身份证</span>
        <el-input class="search-input" placeholder="请输入身份证号" v-model="filterTerm.idCardNo"></el-input>
      </div>
      <el-button :loading="loading" type="primary" @click="filter(0)">查询</el-button>
      <el-button @click="toInfo(0,0)" v-if="accountState===1 && promotorType===1">添加分销商</el-button>
    </div>
    <div class="dis-manager-table white-box">
      <el-table row-class-name="dis-manager-table-tr"
                :data="queryData.promotors"
                style="width: 100%">
        <el-table-column :key="item.prop" v-for="item in distriTableColumn"
                         :prop="item.prop"
                         :label="item.label"
                         :width="item.width">
        </el-table-column>
        <el-table-column
          label="操作"
          width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="toInfo(scope.row.id,1)">查看</el-button>
            <el-button type="text" size="small"
                       v-if="scope.row.accountState=='在职' && accountState===1 && promotorType===1 "
                       @click="toInfo(scope.row.id,0)">编辑
            </el-button>
            <el-button type="text" size="small"
                       v-if="scope.row.accountState=='在职' && accountState===1 && promotorType===1  "
                       @click="dimission(scope.row.id)">离职
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="dis-manager-pag column-content">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryData.curPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="queryData.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="queryData.totalRecords">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {validatePhone} from 'utils/validate';
  import {promotorSearch, promotorLeaveJob} from 'api';

  export default {
    data() {
      const tableProps = ['id', 'name', 'accountState', 'mobile', 'brokerageRatio', 'appRatio', 'orderAmount', 'brokerageAmount', 'createdAt', 'updatedAt']
      const tableTitle = ['ID', '姓名', '状态', '手机号', '站外订单分成比例', 'APP内订单分成比例', '销售金额', '佣金', '创建时间', '操作时间']
      const widths = [70, 110, 70, 130, 100, 110, 100, 120, 120, 130]
      let distriTableColumn = [];
      tableTitle.forEach((item, index) => {
        let temp = {
          prop: tableProps[index],
          label: item,
          width: widths[index]
        };
        distriTableColumn.push(temp)
      });

      const validateMobile = (rule, value, callback) => {
        if (!validatePhone(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      };
      return {
        //控制distributorInfo页面
        infoData: {
          check: false,
          infoId: 1,
        },
        filterTerm: {
          name: '',
          mobile: '',
          idCardNo: '',
          accountState: '',
          createdAtStart: '',
          createdAtEnd: '',
        },
        queryData: {
          curPage: 1,
          pageSize: 20,
          promotors: [],
          totalRecords: 1
        },
        distriTableColumn: distriTableColumn,
        loading: false,
        distributorStatus: [
          {
            value: "-1",
            label: "全部"
          },
          {
            value: "1",
            label: "在职"
          },
          {
            value: "2",
            label: "离职"
          }
        ]
      }
    },
    components: {},
    computed: {
      ...mapGetters([
        'promotorType',
        'accountState'
      ])
    },
    created() {
      let vis = this;
      vis.loading = true;
      promotorSearch().then((res) => {
        vis.loading = false;
        if (res.ret == 0) {
          let resData = res.data;
          const promotorsData = vis.handlePromotor(resData.promotors);
          let queryData = vis.queryData;
          queryData.curPage = resData.curPage;
          queryData.pageSize = resData.pageSize;
          queryData.totalRecords = resData.totalRecords;
          queryData.promotors = promotorsData;
        }
      }).catch(() => {
      })
    },
    methods: {
      bl() {

      },
      handlePromotor(data) {
        data.map(item => {
          for (let i in item) {
            if (i == 'accountState') {
              let t = item[i] == 1 ? '在职' : '离职';
              item[i] = t
            }
          }
        });
        return data
      },
      filter(bringPag) {
        let vis = this;
        const createdAtStart = vis.filterTerm.createdAtStart;
        const createdAtEnd = vis.filterTerm.createdAtEnd;

        let tempForm = JSON.parse(JSON.stringify(vis.filterTerm));

        if (createdAtStart || createdAtEnd) {
          tempForm.createdAtStart = createdAtStart && vis.filterTerm.createdAtStart.getTime();
          tempForm.createdAtEnd = createdAtEnd && vis.filterTerm.createdAtEnd.getTime() + (23 * 3600 + 59 * 60 + 59) * 1000;
          if (createdAtStart && createdAtEnd && tempForm.createdAtStart >= tempForm.createdAtEnd) {
            vis.$message({
              message: '终止日期需大于起始日期，请重新选择',
              type: 'warning'
            });
            vis.filterTerm.createdAtStart = '';
            vis.filterTerm.createdAtEnd = '';
            return
          }
        }
        if (bringPag) {
          tempForm['pageSize'] = vis.queryData.pageSize;
          tempForm['curPage'] = vis.queryData.curPage;
        }
        for (let i in tempForm) {
          if (!tempForm[i]) {
            delete tempForm[i]
          }
        }
        vis.loading = true;
        promotorSearch(tempForm).then(res => {
          vis.loading = false;
          const resData = res.data;
          const promotorsData = vis.handlePromotor(resData.promotors);
          let queryData = vis.queryData;
          queryData.curPage = resData.curPage;
          queryData.pageSize = resData.pageSize;
          queryData.totalRecords = resData.totalRecords;
          queryData.promotors = promotorsData
        })
      },
      handleSizeChange() {
        this.queryData.pageSize = arguments[0];
        this.filter(1)
      },
      handleCurrentChange() {
        this.queryData.curPage = arguments[0];
        this.filter(1);
      },
      dimission(id) {
        let vis = this
        this.$confirm('确定离职改用户吗?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          promotorLeaveJob(id).then(res => {
            this.$message({
              type: 'success',
              message: '离职成功!'
            });
            vis.filter()
          })
        }).catch(() => {
        })
      },
      toInfo(infoId, check) {
        this.$router.push({name: 'distributorDetail', params: {infoId, check}});
//        this.$router.push({name: 'distributorDetail', params: {infoId, check: true}});
      }
    },
  }
</script>

<style lang="scss" scoped>
  .distributor-manager {
    line-height: 50px;
    & > div {
      width: 1100px;
    }
    div.part {
      display: inline-block;
    }
    .dis-manager-search {
      padding: 20px;
      height: 138px;
    }
    .dis-manager-table {
      margin-top: 10px;
    }
    .dis-manager-pag {
      height: 74px;
    }
    .search-input, .el-select {
      width: 200px;
      margin: 0 40px 0 0;
    }
    .part .span-14 {
      width: 65px;
      text-align: right;
      display: inline-block;
    }
    .phone-part {
      margin-right: 75px;
      .span-14 {
        text-align: right;
      }
    }
    .create-time {
      margin-right: 65px;
    }
    .el-date-editor {
      width: 130px;
    }
    .el-button--text {
      color: #f86442;
    }
  }
</style>





// WEBPACK FOOTER //
// distributorManager.vue?37fc967d